module.exports = __webpack_public_path__ + "static/img/iCAS-icon.2d7e14b8.png";